/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpPulumiStacksResponse {
  /**
  * List of initiated job IDs
  */
  'jobIds'?: Array<string>;
  /**
  * List of Pulumi Config IDs that failed to update
  */
  'failedPulumiConfigIds'?: Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "jobIds",
      "baseName": "jobIds",
      "type": "Array<string>",
      "format": "uuid"
    },
    {
      "name": "failedPulumiConfigIds",
      "baseName": "failedPulumiConfigIds",
      "type": "Array<string>",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return UpPulumiStacksResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

